<template>
  <div class="home-footer">
    <div class="home-footer-content">
      <div class="footer-inner">
        <!-- <div class="footer-col"  >
          <h3 class="footer-col-title">资源下载</h3>
          <ul class="footer-list">
            <li>
              <a href="#">全国公务员管理信息系统2025版</a>
            </li>
            <li>
              <a href="#">公务员平板2025版（鸿蒙）</a>
            </li>
            <li>
              <a href="#">干部平板2025版（鸿蒙）</a>
            </li>
          </ul>
        </div> -->

        <div class="footer-col">
          <h3 class="footer-col-title">友情链接</h3>
          <ul class="footer-list">
            <li>
              <a href="https://www.12371.cn/" target="_blank">中国共产党员网</a>
            </li>
            <li>
              <a href="https://www.insigma.com.cn/" target="_blank"
                >浙大网新科技股份有限公司</a
              >
            </li>
            <li>
              <a href="https://www.epsoft.com.cn/" target="_blank"
                >浙江浙大网新软件产业集团</a
              >
            </li>
            <li>
              <a :href="forumUrl" @click.prevent="openForumModal">红云论坛</a>
            </li>
          </ul>
        </div>

        <div class="footer-col footer-col-follow">
          <h3 class="footer-col-title">关注我们</h3>
          <div class="footer-qrcodes">
            <div class="footer-qr-item">
              <div class="footer-qr-img">
                <img :src="imgVxsh" alt="微信视频号" class="footer-qr" />
              </div>
              <p class="footer-qr-caption">微信视频号</p>
            </div>
            <div class="footer-qr-item">
              <div class="footer-qr-img">
                <img :src="imgDy" alt="抖音" class="footer-qr" />
              </div>
              <p class="footer-qr-caption">抖音</p>
            </div>
            <div class="footer-qr-item">
              <div class="footer-qr-img">
                <img :src="imgXhs" alt="小红书" class="footer-qr" />
              </div>
              <p class="footer-qr-caption">小红书</p>
            </div>
            <!-- <div class="footer-qr-item">
              <img :src="imgSian" alt="客服" class="footer-qr" />
              <p class="footer-qr-caption">客服</p>
            </div> -->
          </div>
        </div>

        <div class="footer-col footer-col-contact">
          <h3 class="footer-col-title">公司地址</h3>
          <div class="footer-contact-body">
            <p class="footer-address">公司名称：浙江红云智汇科技有限公司</p>
            <p class="footer-address">公司地址：杭州市西园一路18号浙大网新软件园A座8楼</p>
            <div class="footer-phone-row">
              <img :src="imgTel" alt="" class="footer-phone-icon" />
              <span>公司电话：4008-600797拨1</span>
            </div>
            <div class="footer-phone-row">
              <img :src="imgPhone" alt="" class="footer-phone-icon" />
              <span>联系人：15258875611</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="copyright">
      Copyright © 2019-2026 浙江红云智汇科技有限公司 All Rights Reserved. □
      浙ICP备2026037204号-1
    </p>

    <transition name="dl-modal-fade">
      <div
        v-if="forumModalOpen"
        class="dl-modal"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        aria-labelledby="footer-forum-modal-title"
        @click.self="closeForumModal"
        @keyup.esc="closeForumModal"
      >
        <div class="dl-modal__panel" @click.stop>
          <button
            type="button"
            class="dl-modal__close"
            aria-label="关闭"
            @click="closeForumModal"
          >
            ×
          </button>
          <h3 id="footer-forum-modal-title" class="dl-modal__title forum-modal__title">
            <i class="el-icon-info forum-modal__title-icon" aria-hidden="true"></i>
            站点跳转提醒
          </h3>
          <div class="forum-modal__body">
            <p>你正在跳转至公司内部论坛，访问须知如下：</p>
            <ol class="forum-modal__list">
              <li>
                <span class="forum-modal__item-label">访问前置要求：</span>
                <strong class="forum-modal__em">
                  必须连接公司VPN，未连通VPN无法打开论坛。
                </strong>
              </li>
              <li>
                <span class="forum-modal__item-label">账号登录规则：</span>
                若此前通过公司OA单点登录过论坛，可使用固定账号密码登录：
                <p class="forum-modal__cred">
                  <strong class="forum-modal__em">账号：你的中文姓名</strong>
                </p>
                <p class="forum-modal__cred">
                  <strong class="forum-modal__em"
                    >密码：你在公司oa论坛保存的手机号码@123456Bbs</strong
                  >
                </p>
                <p class="forum-modal__example">
                  例：姓名为张三，手机号码是13012344321，默认用户名密码为：
                  <strong class="forum-modal__em"
                    >张三/13012344321@123456Bbs</strong
                  >
                </p>
                <p class="forum-modal__note">
                  从未单点登录过论坛的人员，请打开论坛页面自行注册账号。
                </p>
              </li>
            </ol>
          </div>
          <div class="dl-form__actions">
            <button
              type="button"
              class="dl-btn dl-btn--ghost"
              @click="closeForumModal"
            >
              取消
            </button>
            <button
              type="button"
              class="dl-btn dl-btn--primary"
              @click="confirmForumModal"
            >
              前往论坛
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const FORUM_URL = "http://192.168.183.101:81/";

export default {
  name: "home-footer",
  data() {
    return {
      imgVxsh: require("@/assets/images/code-vxsp.png"),
      imgDy: require("@/assets/images/code-dy.png"),
      imgXhs: require("@/assets/images/code-xhs.png"),
      imgTel: require("@/assets/images/tel.png"),
      imgPhone: require("@/assets/images/phone.png"),
      forumUrl: FORUM_URL,
      forumModalOpen: false,
    };
  },
  watch: {
    forumModalOpen(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
  methods: {
    openForumModal() {
      this.forumModalOpen = true;
    },
    closeForumModal() {
      this.forumModalOpen = false;
    },
    confirmForumModal() {
      this.closeForumModal();
      window.open(this.forumUrl, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style lang="less">
.home-footer {
  height: 282px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0px 3px rgba(255, 87, 51, 1);
  .home-footer-content {
    position: relative;
    height: calc(100% - 44px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 30px 24px 12px;
  }
  .footer-inner {
    display: flex;
    width: 100%;
    // max-width: 1200px;
    justify-content: space-between;
    justify-content: center;
    align-items: flex-start;
  }
  .footer-col {
    min-width: 0;
    text-align: left;
    margin: 0 80px;
  }
  .footer-col-title {
    margin: 0 0 30px;
    font-size: 20px;
    font-weight: 700;
    color: rgba(27, 27, 27, 1);
    height: 20px;
    line-height: 1;
  }
  .footer-list {
    margin: 0;
    padding: 0;
    list-style: none;
    color: rgba(104, 104, 104, 1);
    font-size: 18px;
    li {
      //   margin-bottom: 8px;
      line-height: 1.5;
      &:last-child {
        margin-bottom: 0;
      }
    }
    a {
      font-size: 16px;
      text-decoration: none;
      &:hover {
        color: rgba(255, 87, 51, 1);
      }
    }
  }
  .footer-qrcodes {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 20px;
    .footer-qr-item {
      .footer-qr-caption {
        margin: 5px 0 0;
        font-size: 16px;
        line-height: 1.4;
        color: rgba(104, 104, 104, 1);
        text-align: center;
      }
    }
  }
  .footer-qr-img {
    display: flex;
    width: 100px;
    height: 100px;
    justify-content: center;
    align-items: center;
    .footer-qr {
      object-fit: contain;
    }
  }
  .footer-contact-body {
    color: rgba(102, 102, 102, 1);
    font-size: 16px;
    line-height: 1.6;
  }
  .footer-address {
    margin: 0 0 2px;
  }
  .footer-phone-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
    img {
      width: 15px;
      height: 15px;
      object-fit: contain;
      flex-shrink: 0;
    }
    &:first-of-type {
      margin-top: 0;
    }
  }

  .copyright {
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: rgba(11, 11, 11, 1);
    font-size: 12px;
    margin: 0;
    border-top: 1px solid rgba(151, 151, 151, 0.2);
  }
}
</style>
